import React, { useState } from 'react';
import AuthService from '../../services/AuthService';
import FooterPages from '../Footer/FooterPages';
import { useNavigate, useLocation } from 'react-router';
import UserService from '../../services/UserService';
import Navbar3 from '../Navbars/Navbar3';

function Dashboard() {
    const navigate = useNavigate();
    const location = useLocation();
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const handleMouseEnter = (index) => setHoveredIndex(index);
    const handleMouseLeave = () => setHoveredIndex(null);

    const renderBrandOptions = (index, attaLink, otherLink) => (
        hoveredIndex === index && (
            <div className='card p-3 position-absolute w-100 mt-2' style={{ zIndex: 10 }}>
                <div className='d-flex flex-column flex-sm-row justify-content-around'>
                    <div className='trybtn3'>
                        <a href={attaLink}>ATTA</a>
                    </div>
                    <div className='trybtn3'>
                        <a href={otherLink}>BI | SX | ND</a>
                    </div>
                </div>
            </div>
        )
    );

    const renderCard = (title, subtitle, description, index, attaLink, otherLink, onClick, isAdminOnly = false) => {
        if (isAdminOnly && !UserService.hasRole(["adminrole"])) return null;

        const isHoverable = attaLink && otherLink;

        return (
            <div
                className="col-md-6 col-sm-6 col-xs-12 mb-3 position-relative"
                onMouseLeave={() => isHoverable && handleMouseLeave()}
            >
                <div className="afterlogcon3box1 h-100">
                    <div className="col-12 padding">
                        <div className='row'>
                            <div className="col-8">
                                <h3>{title}</h3>
                            </div>
                            <div className="col-4">
                                <h4>{subtitle}</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <p>{description}</p>
                        <div className="alborderbottom1"></div>
                        <div className="trybtn"
                            onMouseEnter={() => isHoverable && handleMouseEnter(index)}
                            style={{ cursor: 'pointer' }}
                        >
                            <a
                                style={{ color: 'white' }}
                                onClick={() => onClick?.(index)}
                                aria-label="DE"
                            >
                                {attaLink ? 'Select Brand' : 'Go'} <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon>
                            </a>
                        </div>
                        {attaLink && renderBrandOptions(index, attaLink, otherLink)}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <Navbar3 />
            <div className="container-fluid aftrlogincontainer3">
                <div className="container-fluid row d-flex align-items-stretch">
                    <div className="row">
                        {renderCard(
                            'Refresh Model',
                            'Admin Control',
                            "Refresh Model feature enables the administrator to upload a new Excel file containing updated data and refresh the system's model accordingly.",
                            null,
                            null,
                            null,
                            () => navigate('/refreshmodel'),
                            true
                        )}

                        {renderCard(
                            'Model Performance',
                            'Diagnostics',
                            'Model Performance compares actual outcomes with predicted results to assess accuracy and reliability of the model which provides insights for refining and improving model predictions over time.',
                            null,
                            null,
                            null,
                            () => navigate('/modelperformance')
                        )}

                        {renderCard(
                            'Market Analysis',
                            'Diagnostics',
                            'Market Analysis dissects expenditure trends among single brand with multiple tactics in a specific source of expenditure over a defined time frame, providing valuable insights for analytics.',
                            null,
                            null,
                            null,
                            () => navigate('/marketanalysis'),
                        )}

                        {renderCard(
                            'Brand Analysis',
                            'Diagnostics',
                            'Brand Analysis dissects expenditure trends among single brand with multiple tactics in a specific source of expenditure over a defined time frame, providing valuable insights for analytics.',
                            null,
                            null,
                            null,
                            () => navigate('/brandanalysis')
                        )}

                        {renderCard(
                            'Scenario Planner',
                            'Simulation',
                            'Scenario Planner offers an advanced solution for analyzing expenditure data, transforming raw financial inputs into comprehensive charts, uncovering patterns and trends, enabling users to gain actionable insights.',
                            null,
                            null,
                            null,
                            () => navigate('/simulator')
                        )}

                        {renderCard(
                            'Optimized Spends',
                            'Optimization',
                            'Optimized Spends analyzes expenditure data and user-defined budgets to recommend optimal spending strategies helping in allocation of resources, ensuring maximum return on investment.',
                            null,
                            null,
                            null,
                            () => navigate('/optimizer')
                        )}

                        {renderCard(
                            'Saved Scenarios',
                            'Simulation',
                            'Saved Scenarios analyzes expenditure data and user-defined budgets to recommend optimal spending strategies helping in allocation of resources, ensuring maximum return on investment.',
                            null,
                            null,
                            null,
                            () => navigate('/savedscenarios')
                        )}

                        {renderCard(
                            'Saved Reports',
                            'User Saved',
                            'Saved Reports lets User to access securely their saved reports for future reference and continued analysis.',
                            null,
                            null,
                            null,
                            () => navigate('/savedreports')
                        )}
                    </div>
                </div>
            </div>
            <FooterPages />
        </>
    );
}

export default Dashboard;